var TypeMessagesRMQ = {
  RaceChange: { name: "race-change" },
  EntryChange: { name: "entry-change" },
  RaceCreate: { name: "race-create" },
  EntryCreate: { name: "entry-create" },
  PoolCreate: { name: "pool-create" },
  ResultCreate: { name: "result-create" },
  PoolChange: { name: "pool-change" },
};

export default TypeMessagesRMQ;
